<template>
	<div class="datetime-container is-warning">
		<VueCtkDateTimePicker color="#248dcd" button-color="#248dcd"
		:disabledHours="disabledHours"
		:onlyTime="true" :right="true" :buttonNowTranslation="t('today')" formatted="hh:mm a" :label="usedLabel" v-model="value" format="hh:mm a"></VueCtkDateTimePicker>
		<input type="hidden" :name="InputName" :value="value" >
	</div>
</template>
<script>
	import trans from "../SiteComponents/translation/general.json";
	export default {
		name: 'TimePicker',
		props:{
			OldValue:{
				required:false
			},
			InputName:{
				required:true,
				type:String
			},
			sitelocale:{
				required:true,
				type:String
			},
			disabledHours:{
				required: false,
				type: Array
			},
			label:{
				type:String,
				default: null
			}
		},
		data() {
			return {
				value:"",
				usedLabel:null
			};
		},
		mounted(){
			this.$translate.setLang(this.sitelocale);
			if(this.OldValue){
				this.value = this.OldValue
			}
			if(this.label === null){
				this.usedLabel = this.$translate.text('select_time')
			}else{
				this.usedLabel = this.label
			}
		},
		locales: trans,
	}	
</script>
<style type="text/css">
</style>